import React from 'react';
import { NotificationProvider, useNotifications } from '../../contexts/NotificationContext';
import { ToastContainer } from '../../common/Messages';

const NotificationWrapperInner = ({ children }) => {
    const { notifications, removeNotification, addNotification } = useNotifications();

    // ✅ MIGLIORAMENTO: Gestione più robusta del sistema globale
    React.useEffect(() => {
        // Rendi disponibile globalmente per il hook useToast
        window.addNotification = (message, type = 'info', duration = 3000) => {

            addNotification(message, type, duration);
        };
        
        return () => {
            delete window.addNotification;
        };
    }, [addNotification]);

    return (
        <>
            {children}
            {/* ✅ CRITICAL: ToastContainer renderizzato al top level con Portal interno */}
            <ToastContainer 
                notifications={notifications} 
                onRemove={removeNotification}
            />
        </>
    );
};

const NotificationWrapper = ({ children }) => {
    return (
        <NotificationProvider>
            <NotificationWrapperInner>
                {children}
            </NotificationWrapperInner>
        </NotificationProvider>
    );
};

export default NotificationWrapper;